"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollLinkDto = instanceOfPayrollLinkDto;
exports.PayrollLinkDtoFromJSON = PayrollLinkDtoFromJSON;
exports.PayrollLinkDtoFromJSONTyped = PayrollLinkDtoFromJSONTyped;
exports.PayrollLinkDtoToJSON = PayrollLinkDtoToJSON;
exports.PayrollLinkDtoToJSONTyped = PayrollLinkDtoToJSONTyped;
const PayrollLinkType_1 = require("./PayrollLinkType");
/**
 * Check if a given object implements the PayrollLinkDto interface.
 */
function instanceOfPayrollLinkDto(value) {
    if (!('link' in value) || value['link'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function PayrollLinkDtoFromJSON(json) {
    return PayrollLinkDtoFromJSONTyped(json, false);
}
function PayrollLinkDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'link': json['link'],
        'type': (0, PayrollLinkType_1.PayrollLinkTypeFromJSON)(json['type']),
    };
}
function PayrollLinkDtoToJSON(json) {
    return PayrollLinkDtoToJSONTyped(json, false);
}
function PayrollLinkDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'link': value['link'],
        'type': (0, PayrollLinkType_1.PayrollLinkTypeToJSON)(value['type']),
    };
}
//# sourceMappingURL=PayrollLinkDto.js.map